export default "__VITE_PUBLIC_ASSET__46d3b80b__"